export enum GoalVisibility {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE'
}
